// css =>
import "../../BaseStructure.css";
import Styled from "./fotter.module.css";

function Fotter() {
    return (
        <div className="row">
            <div className="col-12" id={ Styled.FotterBox }>
                <h3>Designed & Developed by HERAM Studio</h3>
            </div>
        </div>
    );
};

export default Fotter;
